import { Mapper } from '../../../@harmony';
import { Timestamp } from 'firebase/firestore';
import { SubscriptionEntity } from '../../../purchases';
import { Subscription } from '../../../purchases/domain/models/subscription.model';

export class SubscriptionToSubscriptionEntityMapper
  implements Mapper<Subscription, SubscriptionEntity>
{
  public map(from: Subscription): SubscriptionEntity {
    return {
      _version: 0,
      status: from.status,
      seats: from.seats,
      endDate: Timestamp.fromDate(from.endDate),
      productId: from.productId,
      priceId: from.priceId,
      customerId: from.customerId,
      subscriptionId: from.subscriptionId,
      price: from.price,
      currency: from.currency,
      interval: from.interval,
      lastSyncedAt: Timestamp.fromDate(from.lastSyncedAt),
    };
  }
}

export class SubscriptionEntityToSubscriptionMapper
  implements Mapper<SubscriptionEntity, Subscription>
{
  public map(from: SubscriptionEntity): Subscription {
    return new Subscription(
      from.status,
      from.seats,
      from.endDate.toDate(),
      from.productId,
      from.priceId,
      from.customerId,
      from.subscriptionId,
      from.price,
      from.currency,
      from.interval,
      from.lastSyncedAt.toDate(),
    );
  }
}
